<template>
  <div style="height: 100%">
    <div class="header">
      <div style="display: flex">
        <div v-for="(item,index) in user.systemList" :key="index" @click="switchedSystem(index)">
          <div style="font-size: 13px;font-weight: bold;width: 130px;text-align: center">
            <div :style="index == user.systemIndex ? 'color: #ff5f61':''">{{item.title}}</div>
          </div>
          <div v-if="index == user.systemIndex" style="border: #ff5f61 1px solid;margin: 12px 4px 0 4px"></div>
        </div>
      </div>
      <div style="display: flex;align-items: center">
<!--        <el-button-group >-->
<!--          <el-tooltip class="item" effect="dark" content="文件存储" placement="left">-->
<!--            <el-button class="tools" size="medium" plain type="primary" icon="el-icon-folder-opened" @click="$refs.fileManager.openDialog()"></el-button>-->
<!--          </el-tooltip>-->
<!--          <el-button class="tools" size="medium" plain type="primary" icon="el-icon-download"></el-button>-->
<!--          <el-button class="tools" size="medium" plain type="primary" icon="el-icon-bell"></el-button>-->
<!--        </el-button-group>-->
        <el-dropdown style="margin-left: 10px">
          <div class="my">
            <div style="display: flex;align-items: center;justify-content:space-between">
              <el-avatar shape="square" size="medium" :src="user.portrait"></el-avatar>
              <div style="display: flex;align-items: center">
                <div style="margin-left: 2px;font-weight: bold">{{user.name}}</div>
                <div class="el-icon-arrow-down el-icon--right"></div>
              </div>
            </div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <div @click="$refs.updatePassword.openDialog()"><span class="menu-icon el-icon-unlock" style="margin-right: 8px"></span>修改密码</div>
            </el-dropdown-item>
            <el-dropdown-item>
              <div @click="backToMain"><span class="menu-icon el-icon-office-building" style="margin-right: 8px"></span>返回焱火后台</div>
            </el-dropdown-item>
            <el-dropdown-item >
              <div @click="exit"><span class="menu-icon el-icon-monitor" style="margin-right: 8px"></span>退出登录</div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <remind/>
    <file-manager ref="fileManager"/>
    <update-password ref="updatePassword"/>
  </div>
</template>

<script>
import '/src/assets/styles.css';
import {Notification} from "element-ui";
import router from "../../../../../router";
import UpdatePassword from "./UpdatePassword";
import FileManager from "./components/fileManager/FileManager";
import Remind from "./Remind";
import {toDoCount} from "../../../../../api/menu";
import {mainSsoUrl} from "../../../../../api/sso";
export default {
  name: "Header",
  components:{UpdatePassword,Remind,FileManager},
  data() {
    return {
      user: {},
    }
  },
  methods:{
    exit(){
      router.replace('/login');
      localStorage.removeItem("user");
      Notification.success({ title: "提醒", message: "退出成功！" });
    },
    /**
     * 反向免登：返回焱火后台管理系统（sport.yanhuotiyu.com）
     *
     * 由本系统后端签发带票地址（sys/auth/mainUrl），浏览器带票打开后台落地页完成免登。
     * 与「主后台 → OA」的免登对称，票据同样 120 秒有效、nonce 一次性。
     *
     * ⚠️ 必须先同步 window.open 拿到窗口句柄、再在异步回调里填地址：
     *    若在 then 回调里才 window.open，浏览器会把它当成「非用户触发」的弹窗直接拦截，
     *    表现为点了没反应（主后台 Header 的「OA办公」踩过同一个坑）。
     */
    backToMain(){
      const win = window.open("", "_blank");
      mainSsoUrl().then(res => {
        if (res && res.status === 200 && res.data && res.data.code === 200 && res.data.data) {
          if (win) {
            win.location.href = res.data.data;
          } else {
            window.location.href = res.data.data;
          }
        } else {
          if (win) {
            win.close();
          }
          Notification.warning({ title: "提醒", message: (res && res.data && res.data.message) || "获取免登地址失败！" });
        }
      }).catch(() => {
        if (win) {
          win.close();
        }
        Notification.warning({ title: "提醒", message: "获取免登地址失败，请稍后重试！" });
      });
    },
    switchedSystem(index){
      this.user.systemIndex = index;
      localStorage.setItem("user",JSON.stringify(this.user));
      let list = this.user.systemList;
      this.$store.commit('setMenuLoading');
        setTimeout(() => {
          this.$store.commit("setMenu",list[index].children);
          console.log(list[index].children)
          this.$store.commit('setMenuLoading');
        }, 500);
        this.select(list[index].children);
    },
    select(list){
      toDoCount().then(val=>{
        if (val.status == 200) {
          let total = val.data.result;
          this.recursion(list,total);
          this.$store.commit("setMenu",list);
        }
      })
    },
    recursion(tree,total){
      // 返回本层所有节点的 badge 合计，供上一层父节点使用
      if (!tree || tree.length === 0){return 0}
      const count = Number(total) || 0;
      let sum = 0;
      for (const item of tree) {
        // 先递归子节点，拿到子树角标合计
        const childSum = this.recursion(item.children,count);
        if (item.index === 'oa/form/todo'){
          // 待办节点：取接口返回的总数
          this.$set(item, 'badge', count);
        } else if (childSum > 0){
          // 父节点：等于所有子节点 badge 之和
          this.$set(item, 'badge', childSum);
        } else {
          // 无未办时置 0（模板中 0 不显示），避免角标残留
          this.$set(item, 'badge', 0);
        }
        sum += item.badge;
      }
      return sum;
    },
  },
  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.$store.commit('setMenuLoading');
    setTimeout(() => {
      let list = this.user.systemList;
      let index = this.user.systemIndex;
      this.$store.commit('setMenuLoading');
      this.select(list[index].children);
    }, 500);

  }
}
</script>

<style scoped>
.header{
  height: 100%;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}
.my{
  border: none;
  padding: 6px 12px 6px 8px;
  width: 108px;
}
.my:hover{
  background-color: #F5F7FA;
  border-radius: 7px;
}
.menu-icon{
  color: red;
  font-weight: bold;
}
.tools{
  font-size: 16px;
  padding: 8px 15px;
}
</style>